import { grid } from '@app/components/package-customize/customize-sheet-item/sheet/utils';

export default {
  nameDesc: '8 - 2x3',
  imageCount: 8,
  displayGroup: 'DG_WALLET',
  calc: (height) => grid(2, 4, height)
};
